// Utils
import { get } from "Utils/HTTPMethods";
import {
  normalizeHealthCard,
  normalizeLastNameForSearch,
} from "Utils/Normalization";

// Common
import { callQBookingApi } from "./common";

export const searchMbsPatients = async ({
  lastName,
  healthCardNumber,
  dateOfBirth,
  nextKey,
  limit,
} = {}) => {
  const params = {};

  if (lastName?.trim()) {
    params.lastNameNormalized = normalizeLastNameForSearch(lastName);
  }

  if (healthCardNumber?.trim()) {
    params.healthCardNumber = normalizeHealthCard(healthCardNumber);
  }

  if (dateOfBirth?.isValid) {
    params.dob = dateOfBirth.toFormat("yyyy-MM-dd");
  }

  if (nextKey) {
    // patch so that it works with guestPatient
    if (typeof nextKey === "string") {
      params.nextKey = nextKey;
    } else {
      params.nextKey = JSON.stringify({
        inSystem: nextKey.inSystem ?? null,
        guest: nextKey.guest ?? null,
      });
    }
  }

  if (limit) {
    params.limit = limit;
  }

  return callQBookingApi(get, "/mbsPatientSearch", params);
};
